<script lang="ts">
	import type { Course } from '$lib/types/hygraph';
	import { classes } from '$lib/utils';
	import { getTranslate } from '@tolgee/svelte';
	import { createEventDispatcher } from 'svelte';
	import ArrowLeftIcon from '../Icon/ArrowLeftIcon.svelte';

	const { t } = getTranslate();
	const dispatch = createEventDispatcher();

	export let course: Course | null | undefined;
	export let additionalClass = '';
</script>

<div
	on:click={() => dispatch('back')}
	on:keydown={() => dispatch('back')}
	on:keyup={() => dispatch('back')}
	class={classes(
		additionalClass,
		'w-full flex items-center bg-black text-white py-10 px-14 cursor-pointer'
	)}
>
	<ArrowLeftIcon />
	<h1 class="ml-8 uppercase text-4xl font-bold">{course?.name}</h1>
</div>
